import { Analytics } from '../services/analytics'

  const pageName = 'Continue: Authentication input'
  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: 'TAN input',
  }

  export const trackInputTan = () => {
    const pageData = {
      [Analytics.keys.eventType(0)]: 'interAction',
      [Analytics.keys.eventAction(0)]: 'Success',
      [Analytics.keys.eventType(0)]: 'Application data',
      [Analytics.keys.linkInformation(0)]: 'Continue: TAN input layer',
    }
    Analytics.setTrackingData({ ...pageData, ...defaultTrackingData })
    Analytics.trackInteraction()
}
export const trackRequestNewTan = () => {
  const pageData = {
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success',
    [Analytics.keys.linkInformation(0)]: 'Continue: TAN input layer: Request new TAN',
  }
  Analytics.setTrackingData({ ...defaultTrackingData, ...pageData})
  Analytics.trackInteraction();
}
export const trackSubmitError = (e:string) => {
  const submitError = {
    [Analytics.keys.errorMessage()]:"Continue: Authentication: Invalid TAN",
    [Analytics.keys.linkInformation(0)]: 'Invalid TAN',
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success',
  }
  Analytics.setTrackingData({ ...defaultTrackingData, ...submitError })
  Analytics.trackInteraction()
}